import angular from 'angular'
import * as _ from 'lodash'
import exceptionTypes from '../errors/exception.types.js'
// import ansMappers from './ans.mappers'

export default [
  '$q',
  'locklessService',
  'metaTemplatesService',
  validationService,
]

function validationService($q, locklessService, metaTemplatesService) {
  /*
   * When an organization dosen't have settings clearly defined, this function should be used to validate the story.
   *
   * Clearification,
   *  https://washpost.slack.com/archives/G1AMSH8JH/p1517403638000337
   *
   * Replaces,
   *  https://github.com/WPMedia/arc-story-builder-ui/blob/62c042d427fe3d74715f9fc537476f1d33ed641e/html/modules/publishActions/publishActions.controller.js#L156
   */

  /*
   * Replaces Block,
   *  https://github.com/WPMedia/arc-story-builder-ui/blob/62c042d427fe3d74715f9fc537476f1d33ed641e/html/modules/publishActions/publishActions.controller.js#L178
   */
  this.validateOrgSettingsVersionOne = function validateOrgSettingsVersionOne(
    storyObj,
    orgSettings
  ) {
    throw new exceptionTypes.EllipsisException({
      message: 'NotImplemented',
      errors: [],
      type: 'error',
    })
  }
  const validationReducer = function validationReducer(acc, item) {
    let storyObj = _.get(acc, 'storyObj')
    if (angular.isUndefined(storyObj)) {
      throw new exceptionTypes.InvalidAttribute({
        errors: [],
        message: 'Missing storyObj',
      })
    }
    let requirements = _.get(acc, 'requirements') || [
      'requiredPublish',
      'requiredSave',
    ]
    // do this until we have strong types
    if (requirements.constructor !== [].constructor) {
      throw new exceptionTypes.InvalidAttribute({
        errors: [],
        message: 'requirements should be []',
      })
    }
    for (let rdx = 0; rdx < requirements.length; rdx++) {
      let value = _.get(item, ['settings', requirements[rdx]].join('.'))
      if (angular.isDefined(value) && value === true) {
        let metaField = _.get(metaTemplatesService.baseMetaTemplates, item.key)
        // Fail fast for the developer
        if (angular.isUndefined(metaField)) {
          throw new exceptionTypes.MissingMetaTemplateField({
            errors: [],
            message: item.key,
          })
        }
        if (!metaField.isValid(storyObj)) {
          throw new exceptionTypes.UIValidationError({
            errors: [
              {
                label: metaField.label,
                tab: metaField.tab,
                key: item.key,
              },
            ],
            message: 'ValidationError',
          })
        }
      }
    }
    return acc
  }
  this.validateFeaturedMedia = (storyObj, orgSettings) => {
    if (!storyObj || !orgSettings || !orgSettings.featuredMedia) {
      return []
    }
    return Object.keys(orgSettings.featuredMedia)
      .map((key) => {
        const featuredMediaItem = orgSettings.featuredMedia[key]
        if (!featuredMediaItem.requiredToPublish) {
          return null
        }
        const promoObject = _.get(storyObj, ['promo_items', key])
        if (promoObject && Object.keys(promoObject).length > 0) {
          return null
        }
        return {
          key: 'promo_items',
          label: `Featured Media (${featuredMediaItem.label})`,
          tab_name: 'Featured Media',
        }
      })
      .filter((errorItem) => !!errorItem)
  }
  /*
   * Replaces Block,
   *  https://github.com/WPMedia/arc-story-builder-ui/blob/62c042d427fe3d74715f9fc537476f1d33ed641e/html/modules/publishActions/publishActions.controller.js#L150
   */
  this.validateOrgSettingsVersionTwo = function validateOrgSettingsVersionTwo(
    storyObj,
    orgSettings
  ) {
    if (!orgSettings.featuredMedia) {
      throw new exceptionTypes.UIValidationError({
        message: 'ValidationError',
        errors: [
          {
            key: 'featuredMedia',
            label: `Featured Media Settings should be configured`,
            tab_name: 'Settings',
          },
        ],
      })
    }

    let errorCollection = this.validateFeaturedMedia(storyObj, orgSettings)

    orgSettings.v2.planning.reduce(function reducerRunner(acc, item) {
      try {
        validationReducer(
          { requirements: ['requiredPublish'], storyObj: storyObj },
          item
        )
      } catch (error) {
        Array.prototype.push.apply(errorCollection, error.errors)
      }
    }, [])
    orgSettings.v2.metas.reduce(function reducerRunner(acc, item) {
      try {
        validationReducer(
          { requirements: ['requiredPublish'], storyObj: storyObj },
          item
        )
      } catch (error) {
        Array.prototype.push.apply(errorCollection, error.errors)
      }
    }, [])
    if (errorCollection.length > 0) {
      throw new exceptionTypes.UIValidationError({
        message: 'ValidationError',
        errors: errorCollection,
      })
    }
    return {}
  }
  this.validatePublication = function validatePublication(storyObj) {
    const defer = $q.defer()
    locklessService.loadSettings().then(
      function loadSettingsSuccess(orgSettings) {
        const orgSettingsV2 = _.get(orgSettings, 'v2')
        try {
          if (angular.isDefined(orgSettingsV2)) {
            defer.resolve(
              this.validateOrgSettingsVersionTwo(storyObj, orgSettings)
            )
          } else {
            defer.resolve(
              this.validateOrgSettingsVersionOne(storyObj, orgSettings)
            )
          }
        } catch (error) {
          defer.reject(error)
        }
      }.bind(this)
    )
    return defer.promise
  }.bind(this)
}
